module.exports = __webpack_public_path__ + "img/play.f920e4c7.svg";